import styled from 'styled-components';

export const StyledMessagesContainer = styled.div`
    margin-bottom: 36px;
`;

export const StyledMessagesPositioner = styled.div`
    min-width: 300px;
    position: relative;
    margin: auto;
`;
